__turbopack_context__.v({
  "sliderContainer": "SliderWithTicks-module-scss-module__mxaqia__sliderContainer",
  "tick": "SliderWithTicks-module-scss-module__mxaqia__tick",
  "ticksOverlay": "SliderWithTicks-module-scss-module__mxaqia__ticksOverlay",
});
